import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgLimitsRoute(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="3 -4 18 24" {...props}>
      <path
        d="M6.5 6C8.435 6 10 7.581 10 9.538c0 .614-.182 1.305-.515 2.061a13.31 13.31 0 01-1.09 1.954 21.241 21.241 0 01-1.569 2.077L6.5 16l-.326-.37a21.667 21.667 0 01-1.569-2.076 13.275 13.275 0 01-1.09-1.955C3.181 10.843 3 10.153 3 9.54v-.001C3 7.582 4.565 6 6.5 6zM15 7l2 2-2.572.672L16 12c.381.604-.117 1.476-.82 1.596L10 14.654l1-2.154 2.364-.622-1.579-2.496C11.444 8.841 11.398 8.216 12 8zM5.75 8.2a1.5 1.5 0 101.5 2.6 1.5 1.5 0 00-1.5-2.6zM18 0c1.652 0 3 1.266 3 2.85 0 .497-.157 1.05-.443 1.653-.262.54-.571 1.055-.923 1.54-.407.571-.85 1.116-1.325 1.63L18 8l-.31-.326a16.774 16.774 0 01-1.324-1.63c-.352-.486-.66-1-.923-1.54C15.157 3.9 15 3.346 15 2.848 15 1.266 16.348 0 18 0zm0 2a1 1 0 100 2 1 1 0 000-2z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('LimitsRoute')(SvgLimitsRoute);
